let previousRespId;


const sendInventoryIssue = async () => {
  let item = document.getElementById('prd_invtry_issue_nieukwoop--js');
  let atc_btn = item.parentElement.querySelector('form .product-form__buttons button');
  let prd_form_elm = item.parentElement.querySelector('product-form');
  let stock;
  let startTime = performance.now();

  // prd_id: parseInt(item.dataset.id),
  // var_id: parseInt(item.dataset.varId),

  const raw = {
    sku: item.dataset.sku,
    tag: item.dataset.isNieukwoop == 'true' ? 'nieuwkoop' : 'other'
  };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(raw),
  };

  try {
    const response = await fetch("https://flowersandplantsmall.com/api/inventory-get-stock.php", requestOptions);
    let result = await response.text();
    result = JSON.parse(result);
    stock = result.stock;

    if(stock == 0){
      atc_btn.setAttribute('disabled', 'true');
      atc_btn.innerHTML = "Sold out";
    }else if(stock > 0 && atc_btn.disabled == true){
      atc_btn.removeAttribute('disabled', 'false');
      atc_btn.innerHTML = "Add to cart";
      prd_form_elm.nextElementSibling.style.display = 'none';
    }

    if(stock != null && stock != undefined ){
      let raw2 = {...raw, stock: stock}
      const requestOptions2 = { ...requestOptions, body: JSON.stringify(raw2)};
  
      const response2 = await fetch("https://flowersandplantsmall.com/api/inventory-shopify-update.php", requestOptions2);
      let result2 = await response2.text();
      result2 = JSON.parse(result2);
    }else{ console.log('Not a Nieuwkoop Product') }
    
  } catch (error) {
    console.error("Error:", error);
  }

  let endTime = performance.now(); // End timer //{startTime,endTime}
  console.log(`Time taken to Fetch Stock: ${((endTime - startTime).toFixed(2) / 1000 ).toFixed(2)} s`);
};
 

document.addEventListener('DOMContentLoaded', () => {
  if(window.location.href.includes('/products/')){ sendInventoryIssue() }
})


// ai chat box


// const openBtn = document.getElementById("aichat-openChatBtn");
const floatingBtn = document.getElementById("aichat-floatingBtn");
const overlay = document.getElementById("aichat-overlay");
const closeBtn = document.getElementById("aichat-closeBtn");
// const sendBtn = document.getElementById("aichat-sendBtn");
// const input = document.getElementById("aichat-input");
const content = document.getElementById("aichat-content");

const showChat = () => {
  overlay.classList.remove("aichat-hidden");
  // document.body.classList.add('chat-bot-open')
}
const hideChat = () => {  
  overlay.classList.add("aichat-hidden");
  // document.body.classList.remove('chat-bot-open')
  const reactModalSheetContainer = document.querySelector(".react-modal-sheet-container");
  if(reactModalSheetContainer){
    const parentDiv = reactModalSheetContainer?.closest("div");
    if(parentDiv){
      parentDiv.classList.remove('hidden');
    }
  }
}
// openBtn.addEventListener("click", showChat);
floatingBtn.addEventListener("click", showChat)
closeBtn?.addEventListener("click", hideChat);

// async function handleSend() {
//   const msg = input.value.trim();
//   if (!msg) return;
//   addMessage(msg, true);
//   input.value = "";
//   showLoading(true);
//   const reply = await getAIReply(msg);
//   showLoading(false);
//   addMessage(reply, false);

//   // const data = await fetch('http://localhost/test.php', {
//   //   method:"GET",
//   //   headers : {
//   //     "content-type" : "application/json"
//   //   }
//   // }); 
  
// }

// function showLoading(status){
//   if(status){
//     const html = `<div id="typing-indicator" class="typing-indicator" >
//       <span></span><span></span><span></span>
//     </div>`
//     addMessage(html, false)
//   }else{
//     document.getElementById('typing-indicator')?.remove();
//   }
// }

function overlayHandler(e){
  const aichatBox = e.target.closest('#aichat-box');
  if(!aichatBox){
    hideChat();
  }
  
}


async function getAIReply(input) {
  console.log(previousRespId,'previouse reap id here...');
  
  try {
    const lowerInput = input.toLowerCase();

    const res = await fetch('https://aa.miraclewebsoft.com/api/open-ai', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt: lowerInput, prevRespId: previousRespId }),
    });

    if (!res.ok) {
      const errorData = await res.json();
      return 'Unknown error from API';
    }

    const data = await res.json();
    previousRespId = data?.prevRespId;

    return data?.response || 'No response received.';
  } catch (error) {
    console.log('error', error)
    return `Network or server error: ${error.message}`;
  }
}




 const suggestions = [
      "How often should I water my Monstera?",
      "What houseplants are best for low light?",
      "Which plants are safe for pets?",
      "How do I propagate a String of Hearts?"
    ];

    const suggestionsContainer = document.getElementById("chatSuggestions");
    const messagesContainer = document.getElementById("chatMessages");
    const chatMinScreenCon = document.querySelector(".chat-min-h-screen");
    const form = document.getElementById("chatForm");
    const chatFormPrdPage = document.getElementById("chatInputForm");
    const input = document.getElementById("chatInput");
    const chatInputPrdPage = document.getElementById("chatInputPrdPage");

    let isLoading = false;

    suggestions.forEach((question) => {
      const btn = document.createElement("button");
      btn.className = "chat-suggestion-btn";
      btn.textContent = question;
      btn.onclick = () => handleSendMessage(question);
      suggestionsContainer.appendChild(btn);
    });

    async function handleSendMessage(text, fromPrdPage) {
      if (!text.trim() || isLoading) return;
      document.getElementById('chatSuggestions')?.classList?.add("hidden");
      
      let userInp;
      if(fromPrdPage){
        userInp = `${text} (${window.location.href})`;
        chatInputPrdPage.value = "";
        messagesContainer.innerHTML = "";
        previousRespId = "";
      }else{
        userInp = text;
      }

      addMessage(text, true);
      input.value = "";
      isLoading = true;


      const loadingEl = document.createElement("div");
      loadingEl.className = "chat-msg-ai";
      loadingEl.innerHTML = `
        <div class="chat-bubble chat-bubble-ai chat-thinking">
          <div class="chat-dot"></div>
          <div class="chat-dot"></div>
          <div class="chat-dot"></div>
        </div>`;
      messagesContainer.appendChild(loadingEl);
      chatMinScreenCon.scrollTop = chatMinScreenCon.scrollHeight;

      
      const reply = await getAIReply(userInp);
        loadingEl.remove();
        addMessage(reply, false);
          isLoading = false;
      // setTimeout(() => {
      // }, 2000);
      }

    function addMessage(text, isUser) {
      const messageWrapper = document.createElement("div");
      messageWrapper.className = isUser ? "chat-msg-user" : "chat-msg-ai";

      const bubble = document.createElement("div");
      bubble.className = `chat-bubble ${isUser ? "chat-bubble-user" : "chat-bubble-ai"}`;
      bubble.innerHTML = isUser ? text : marked.parse(text);  // parse markdown to HTML;

      messageWrapper.appendChild(bubble);
      messagesContainer.appendChild(messageWrapper);
      // messagesContainer.scrollTop = messagesContainer.scrollHeight;
      chatMinScreenCon.scrollTop = chatMinScreenCon.scrollHeight;

    }

    // function getPlantAdvice(question) {
    //   const lower = question.toLowerCase();
    //   if (lower.includes('monstera') && lower.includes('water')) {
    //     return "Monsteras prefer to dry out between waterings. Water when the top 1-2 inches of soil feel dry...";
    //   } else if (lower.includes('low light')) {
    //     return "Great low-light houseplants include: Snake plants, ZZ plants, Pothos, Peace lilies...";
    //   } else if (lower.includes('safe') && lower.includes('pets')) {
    //     return "Pet-safe plants include: Spider plants, Boston ferns, Parlor palms...";
    //   } else if (lower.includes('string of hearts') && lower.includes('propagate')) {
    //     return "String of Hearts is super easy to propagate...";
    //   }
    //   return "I'd be happy to help with your plant care question! Could you provide more details?";
    // }

    form.onsubmit = (e) => {
      e.preventDefault();
      handleSendMessage(input.value);
    };

    if(chatFormPrdPage){
      chatFormPrdPage.onsubmit = (e) =>{
        e.preventDefault();
        showChat();
        handleSendMessage(chatInputPrdPage.value, true);
      }
    }

function showTerms(show){
  const chatTermsContent = document.querySelector('.chat-terms-content')
  if(show){
    chatTermsContent?.classList?.remove('hidden')
  }else{
    chatTermsContent?.classList?.add('hidden')
  }
}

function inputFocusHanler(elm) {
  // setTimeout(() => {
  //   elm.scrollIntoView({ behavior: 'smooth', block: 'center' });
  // }, 300);

  const reactModalSheetContainer = document.querySelector(".react-modal-sheet-container");
  if(reactModalSheetContainer){
    const parentDiv = reactModalSheetContainer?.closest("div");
    if(parentDiv){
      parentDiv.classList.add('hidden');
    }
  }
}

document.addEventListener("DOMContentLoaded", function() {
  console.log('dkdkdk....');
  
  function showChatBotAfterLoadingMobile() {
    const chatBotMobileIconContainer = document.querySelector(".chat-bot-mobile-icon-container");
    if(chatBotMobileIconContainer){
      chatBotMobileIconContainer.querySelector('.chat-div-menu-loading')?.classList.add("hidden");
      chatBotMobileIconContainer.querySelector('.header__icon')?.classList.remove("hidden");
    } 
  }
  
  let intervalID = setInterval(checkForModal, 2000);
  let timeoutID = setTimeout(forceStop, 12000);

  function checkForModal() {
    
    const reactModalSheetContainer = document.querySelector('.react-modal-sheet-container');
    const giftboxFirstVisit = sessionStorage.getItem("giftbox-first-visit");

    if (reactModalSheetContainer || giftboxFirstVisit) {
        
      clearInterval(intervalID);
      clearTimeout(timeoutID);
      setTimeout(()=>{        
        showChatBotAfterLoadingMobile();
      }, 1600)
    }
  }

  function forceStop() {
    clearInterval(intervalID); // just in case it wasn't cleared
    showChatBotAfterLoadingMobile();
  }

  function callOpenAiPopup() {
    const aiButton = document.querySelector(".leafyai-custom-button .button");
    if(aiButton){
      aiButton.addEventListener("click", (e) =>{
        e.preventDefault();
        showChat()
      });
    }
  }
  callOpenAiPopup();
});



// window.handleFreeGift = () => {
//   let timeout;
//   return async (cart) => {
//     clearTimeout(timeout);
//     timeout = setTimeout(() => {

//       let qualifiedGiftIds = [];
//       const addToCart = [];
//       const cartSubtotal = cart?.items_subtotal_price / 100;
      
//       const giftItems = Array.from(document.querySelectorAll('.pb-product-item-main[fgvid]')).map(el => ({
//         id: Number(el.getAttribute('fgvid')),
//         limit: Number(el.querySelector('[fgl]')?.getAttribute('fgl') || 0)
//       }));

//       giftItems.forEach(gift => {
//         if (gift.limit === 0 || cartSubtotal >= gift.limit) {
//           qualifiedGiftIds.push(gift.id);
//           console.log(`🔔 Gift ID ${gift.id} is eligible based on limit only (limit: ${gift.limit})`);
//         }
//       });

//       console.log('Gift Items:', giftItems);
//       console.log('Cart Subtotal:', cartSubtotal);
//       console.log('cart:', cart);



//       const cartItemIds = cart?.items?.map(item => item.id) || [];
//       qualifiedGiftIds = qualifiedGiftIds.filter(id => !cartItemIds.includes(id));

//       console.log('qualifiedGiftIds', qualifiedGiftIds);

//       if (qualifiedGiftIds.length > 0) {
//         let data = {
//           items: []
//         };

//         qualifiedGiftIds?.forEach(id => {
//           data.items.push({
//             id: id,
//             quantity: 1,
//             properties: {
//               _ctm_free_gift: true
//             }
//           });
//         });

//         await freeGiftAddToCart(data);
//       }


        
//       // if (cart?.items.length > 0) {
//       //   const freeGiftMatches = giftItems.filter(g => g.limit === 0);
//       //   freeGiftMatches.forEach(freeGift => {
//       //     if (!qualifiedGiftIds.includes(freeGift.id)) {
//       //       addToCart.push(freeGift.id);
//       //     }
//       //   });
//       // }



//       // Final qualified free gift IDs array
//       // console.log('Qualified Free Gift IDs:', qualifiedGiftIds);






//     }, 500);
//   };
// };


// const freeGiftAddToCart = (item) => {
//   try {
//     const response = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify(item)
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! status: ${response.status}`);
//     }

//     const data = await response.json();
//     console.log('✅ Added to cart:', data);
//     return data;
//   } catch (error) {
//     console.error('❌ Add to cart failed:', error);
//   }
// }


window.handleFreeGift = (() => {
  let timeout;

  return async (cart) => {
    clearTimeout(timeout);

    timeout = setTimeout(async () => {

      if (!cart) cart = await freeGiftFetchCart();

      console.log('cart', cart);
      

      const cartPage = window.location.href.includes('/cart');
      let qualifiedGiftIds = [];
      let removedGiftsId = [];
      const addToCart = [];

      const freeGiftPrices = cart.items.filter(item => item.properties && item.properties._ctm_free_gift === true).reduce((sum, item) => sum + item.final_price, 0);
      // console.log("freeGiftPrices", freeGiftPrices);

      const cartSubtotal = (cart?.items_subtotal_price - freeGiftPrices)/ 100;
      // console.log("cartSubtotal", cartSubtotal);

      const giftItems = Array.from(document.querySelectorAll('.pb-product-item-main[fgvid]')).map(el => ({
        id: Number(el.getAttribute('fgvid')),
        limit: Number(el.querySelector('[fgl]')?.getAttribute('fgl') || 0)
      }));

      giftItems.forEach(gift => {        
        if ((gift.limit === 0 && cart?.items.length > 0 ) || cart?.items.length > 0 && cartSubtotal >= gift.limit) qualifiedGiftIds.push(gift.id);
        else removedGiftsId.push(gift.id);
      });


      // console.log('cart:', cart);
      const cartItemIds = cart?.items?.map(item => item.id) || [];

      qualifiedGiftIds = qualifiedGiftIds?.filter(id => !cartItemIds.includes(id));
      if (qualifiedGiftIds.length > 0) {
        const freeGift = await localStorage.getItem('free_gift');
        if (freeGift) {
          const parsedFreeGift = JSON.parse(freeGift);
          const updatedFreeGift = {};

          qualifiedGiftIds = qualifiedGiftIds.filter(id => {
            const value = parsedFreeGift[id];
            const cartLength = cart?.items?.length || 0;

            if (cartLength > value) {
              return true;
            } else {
              updatedFreeGift[id] = cartLength;
              return false;
            }
          });

          if (Object.keys(updatedFreeGift).length > 0) {
            localStorage.setItem('free_gift', JSON.stringify(updatedFreeGift));
          }

        }
        if (qualifiedGiftIds.length > 0) {
          await freeGiftAddToCart(qualifiedGiftIds);
          cartPage && window.location.reload();
        }
        return;
      }

      

      removedGiftsId = removedGiftsId?.filter(id => cartItemIds.includes(id));
      if (removedGiftsId.length > 0){
        const removedGiftsKeys = cart?.items.filter(item => removedGiftsId.includes(item.id)).map(item => item.key);
        await removeCartItems(removedGiftsKeys);
        cartPage && window.location.reload()
        return;
      }

      if (cart?.items.length >= 1) {
        const allFreeGiftExist = cart.items.every(item => {
          const properties = item?.properties || {};
          return Object.keys(properties).some(key => key.includes('_ctm_free_gift'));
        });
        if (allFreeGiftExist) {
          await fraaGiftClearCart();
          cartPage && window.location.reload();
        }
      }


    }, 800);
  };
})();


// ✅ Make sure this function is async
const freeGiftAddToCart = async (qualifiedGiftIds) => {

  let data = {
    items: []
  };

  qualifiedGiftIds.forEach(id => {
    data.items.push({
      id: id,
      quantity: 1,
      properties: {
        _ctm_free_gift: true
      }
    });
  });

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    await response.json();
    const cart = await freeGiftFetchCart();
    await halo.updateSidebarCart(cart);

  } catch (error) {
    console.error('❌ Add to cart failed:', error);
  }
};


const freeGiftFetchCart = async () => {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`❌ Cart fetch failed: ${response.status}`);
    }

    const cart = await response.json();
    return cart;

  } catch (error) {
    console.error('❌ Error fetching cart:', error);
    return null;
  }
};


const removeCartItems = async (itemKeys = [], clearCart = false) => {
  try {
    if (!Array.isArray(itemKeys) || itemKeys.length === 0) {
      console.warn('⚠️ No item keys provided for removal.');
      return;
    }

    const updates = {};
    itemKeys.forEach(key => {
      updates[key] = 0;
    });

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!response.ok) {
      throw new Error(`❌ Cart update failed: ${response.status}`);
    }

    const result = await response.json();
    const cart = await freeGiftFetchCart();
    await halo.updateSidebarCart(cart);

  } catch (error) {
    console.error('❌ Error removing items:', error);
  }
};


async function fraaGiftClearCart() {
  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const cart = await freeGiftFetchCart();
    await halo.updateSidebarCart(cart);
    if (localStorage.getItem('free_gift') !== null) localStorage.removeItem('free_gift');

  } catch (error) {
    console.error('❌ Failed to clear cart:', error);
  }
}



window.removedFreeGift = (id, element) => {
  const parentList = element.closest('.previewCartList') || element.closest('.cart-list');
  if (parentList) {
    const childCount = parentList.children.length;
    const count = childCount - 1;

    const data = {
      [id]: count,
    };
    localStorage.setItem('free_gift', JSON.stringify(data));
  }
};


document.addEventListener('DOMContentLoaded', () => {
  if (window.location.href.includes('/cart')) {
    handleFreeGift();
  }
});

/* ===== FIX SLICK DOTS ARIA (Ella theme) =====
   Moves state off <li role="presentation"> and onto its inner <button>.
   Clears Lighthouse: “[aria-*] attributes do not match their roles”.
*/
(function () {
  function cleanDots(ul) {
    if (!ul) return;

    // The dots list should be a tablist
    ul.setAttribute('role', 'tablist');

    // Keep <li> purely presentational, strip invalid ARIA
    ul.querySelectorAll('li').forEach(function (li) {
      li.setAttribute('role', 'presentation');
      li.removeAttribute('aria-hidden');
      li.removeAttribute('aria-selected');
      li.removeAttribute('aria-controls');

      // Buttons are the interactive controls
      var btn = li.querySelector('button');
      if (!btn) return;

      if (!btn.hasAttribute('type')) btn.setAttribute('type', 'button');
      btn.setAttribute('role', 'tab');

      // Friendly label if missing
      if (!btn.hasAttribute('aria-label')) {
        var idxForLabel = Array.prototype.indexOf.call(li.parentNode.children, li);
        btn.setAttribute('aria-label', 'Go to slide ' + (idxForLabel + 1));
      }

      // Map the dot to the correct slide panel id inside the same slider
      if (!btn.hasAttribute('aria-controls')) {
        var idx = Array.prototype.indexOf.call(li.parentNode.children, li);
        var sliderRoot = li.closest('.slick-slider');
        if (sliderRoot) {
          var slides = sliderRoot.querySelectorAll('.slick-track .slick-slide');
          var slide = slides && slides[idx];
          // Prefer a real panel id if present; otherwise skip aria-controls
          if (slide && slide.id) {
            btn.setAttribute('aria-controls', slide.id);
          }
        }
      }
    });

    // Selected state must live on the BUTTON, not the LI
    var lis = Array.from(ul.querySelectorAll('li'));
    lis.forEach(function (li) {
      var btn = li.querySelector('button');
      if (btn) {
        btn.setAttribute('aria-selected', 'false');
        btn.removeAttribute('aria-current');
      }
    });
    var activeLi = ul.querySelector('li.slick-active');
    if (activeLi) {
      var activeBtn = activeLi.querySelector('button');
      if (activeBtn) {
        activeBtn.setAttribute('aria-selected', 'true');
        activeBtn.setAttribute('aria-current', 'true');
      }
    }
  }

  function sweepAll() {
    document.querySelectorAll('ul.slick-dots').forEach(cleanDots);
  }

  function bindSlickEventsIfAvailable() {
    // Prefer Slick's own events when jQuery is present
    if (window.jQuery) {
      var $ = window.jQuery;
      $(document)
        .off('.ellaAriaFix') // avoid duplicate bindings on reloads
        .on('init.ellaAriaFix afterChange.ellaAriaFix', '.slick-initialized', function (e, slick) {
          if (slick && slick.$dots && slick.$dots[0]) cleanDots(slick.$dots[0]);
        });
    }
  }

  // Observe DOM (captures Quick View, section loads, etc.)
  var mo = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes && m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('ul.slick-dots')) { cleanDots(n); }
        if (n.querySelectorAll) {
          n.querySelectorAll('ul.slick-dots').forEach(function (ul) { cleanDots(ul); });
        }
      });
    });
  });

  function start() {
    sweepAll();                 // fix anything already on page
    bindSlickEventsIfAvailable();
    mo.observe(document.body, { childList: true, subtree: true }); // keep fixing future dots
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* ---- GLOBAL A11y sweeper: ensure inputs have accessible names ---- */
(function () {
  function hasAccessibleName(el) {
    if (!el) return false;
    if (el.hasAttribute('aria-label')) return true;
    if (el.hasAttribute('aria-labelledby')) {
      const ids = (el.getAttribute('aria-labelledby') || '').split(/\s+/).filter(Boolean);
      if (ids.some(id => document.getElementById(id))) return true;
    }
    if (el.id && document.querySelector('label[for="'+el.id+'"]')) return true;
    if (el.closest('label')) return true; // wrapped by a label
    return false;
  }

  function textFrom(el) {
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g,' ').trim();
  }

  function nearestText(el) {
    // Try sibling label, enclosing label, aria-describedby, placeholder, value, name
    if (el.id) {
      const lab = document.querySelector('label[for="'+el.id+'"]');
      if (lab) return textFrom(lab);
    }
    const wrapLab = el.closest('label');
    if (wrapLab) return textFrom(wrapLab);
    const described = el.getAttribute('aria-describedby');
    if (described) {
      const t = described.split(/\s+/).map(id => textFrom(document.getElementById(id))).join(' ').trim();
      if (t) return t;
    }
    if (el.getAttribute('placeholder')) return el.getAttribute('placeholder').trim();
    if (el.type === 'radio' || el.type === 'checkbox') {
      // common: variant swatch inputs next to a label/span
      const lbl = el.nextElementSibling;
      const txt = textFrom(lbl);
      if (txt) return txt;
      // try parent
      const parentTxt = textFrom(el.parentElement);
      if (parentTxt) return parentTxt;
      if (el.value) return el.value;
    }
    if (el.name) return el.name.replace(/[_\-]/g, ' ');
    return '';
  }

  function labelise(el, fallback) {
    if (!el || hasAccessibleName(el)) return;
    const label = (fallback || nearestText(el) || '').trim();
    if (label) el.setAttribute('aria-label', label);
  }

  function sweep(root) {
    const scope = root || document;

    // 1) All form controls
    scope.querySelectorAll('input, textarea, select').forEach(el => {
      // Skip hidden/disabled
      if (el.type === 'hidden' || el.disabled) return;
      labelise(el);
    });

    // 2) Variant radios (Ella swatches)
    scope.querySelectorAll('input[type="radio"][name^="option"], input[type="radio"][name^="properties"], input[type="radio"][name="id"]').forEach(el => {
      if (!hasAccessibleName(el)) {
        // Prefer swatch text
        const txt = nearestText(el) || el.value || 'Option';
        el.setAttribute('aria-label', txt);
      }
    });

    // 3) Quick-shop quantity fields inside sliders
    scope.querySelectorAll('.quickshop, .card, .product-card, .product-item').forEach(card => {
      const qty = card.querySelector('input[name="quantity"][type="number"]');
      if (qty && !hasAccessibleName(qty)) {
        qty.setAttribute('aria-label', 'Quantity');
      }
    });

    // 4) Search inputs (header/drawer/modal)
    scope.querySelectorAll('input[type="search"], input[name="q"]').forEach(el => {
      if (!hasAccessibleName(el)) el.setAttribute('aria-label', 'Search');
    });

    // 5) Newsletter emails
    scope.querySelectorAll('input[type="email"][name="contact[email]"], form[action*="contact"] input[type="email"]').forEach(el => {
      if (!hasAccessibleName(el)) el.setAttribute('aria-label', 'Email address');
    });

    // 6) Price range filters
    scope.querySelectorAll('input[name="filter.v.price.gte"]').forEach(el => { if (!hasAccessibleName(el)) el.setAttribute('aria-label','Minimum price'); });
    scope.querySelectorAll('input[name="filter.v.price.lte"]').forEach(el => { if (!hasAccessibleName(el)) el.setAttribute('aria-label','Maximum price'); });
  }

  // Initial and future content (important for Slick/Quick View)
  function start() {
    sweep(document);
    // When Slick changes slides or sections load, sweep again
    if (window.jQuery) {
      var $ = window.jQuery;
      $(document)
        .off('.a11ySweep')
        .on('init.a11ySweep afterChange.a11ySweep', '.slick-initialized', function (e, slick) {
          if (slick && slick.$slider && slick.$slider[0]) sweep(slick.$slider[0]);
        });
    }
    new MutationObserver((muts) => {
      if (!muts.some(m => m.addedNodes && m.addedNodes.length)) return;
      sweep(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* Give all submit controls an explicit accessible name */
(function () {
  function nameSubmit(el){
    if (el.hasAttribute('aria-label')) return;
    const txt = (el.value || el.textContent || '').trim() || 'Submit';
    el.setAttribute('aria-label', txt);
  }
  function sweep(scope){
    const root = scope || document;
    root.querySelectorAll('input[type="submit"], button[type="submit"]').forEach(nameSubmit);
  }
  function start(){
    sweep(document);
    // re-apply when sliders change or DOM updates
    if (window.jQuery) {
      var $ = window.jQuery;
      $(document).on('init.a11ySubmit afterChange.a11ySubmit', '.slick-initialized', function(e, slick){
        if (slick && slick.$slider && slick.$slider[0]) sweep(slick.$slider[0]);
      });
    }
    new MutationObserver(m => {
      if (m.some(x => x.addedNodes && x.addedNodes.length)) sweep(document);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* ========= A11y: ensure ALL Slick arrows have an accessible name ========= */
(function(){
  function ensureHiddenText(btn, text){
    // Make sure SRs have a text node even if the SVG fails
    if (!btn.querySelector('.visually-hidden')) {
      var s = document.createElement('span');
      s.className = 'visually-hidden';
      s.textContent = text;
      // Prefer to insert before SVG so text is first for SRs
      var svg = btn.querySelector('svg');
      if (svg && svg.parentNode === btn) btn.insertBefore(s, svg);
      else btn.appendChild(s);
    }
  }

  function labelArrows(root){
    (root || document).querySelectorAll('button.slick-prev, button.slick-next').forEach(function(b){
      var isPrev = b.classList.contains('slick-prev');
      var label  = isPrev ? 'Previous slide' : 'Next slide';

      // Explicit accessible name
      if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', label);
      if (!b.getAttribute('title'))      b.setAttribute('title', label);

      // SVGs should be decorative
      b.querySelectorAll('svg').forEach(function(svg){
        if (!svg.getAttribute('aria-hidden')) svg.setAttribute('aria-hidden', 'true');
        svg.removeAttribute('role');
        svg.removeAttribute('focusable');
      });

      // Hidden text fallback
      ensureHiddenText(b, label);
    });
  }

  function bindSlick(){
    if (!window.jQuery) return;
    var $ = window.jQuery;
    $(document)
      .off('.a11yArrowLabels')
      .on(
        // cover all lifecycle moments where arrows may be re-rendered
        'init.a11yArrowLabels reInit.a11yArrowLabels setPosition.a11yArrowLabels afterChange.a11yArrowLabels breakpoint.a11yArrowLabels',
        '.slick-initialized',
        function(e, slick){
          if (slick && slick.$slider && slick.$slider[0]) labelArrows(slick.$slider[0]);
        }
      );
  }

  function start(){
    // run now
    labelArrows(document);
    bindSlick();

    // also sweep shortly after load (some sliders init late)
    setTimeout(function(){ labelArrows(document); }, 300);
    setTimeout(function(){ labelArrows(document); }, 1200);

    // keep watching for dynamically injected sliders/arrows
    new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){
        var m = muts[i];
        for (var j=0;j<m.addedNodes.length;j++){
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('button.slick-prev,button.slick-next') || n.matches('.slick-initialized'))) {
            labelArrows(document);
            return;
          }
          if (n.querySelector){
            if (n.querySelector('button.slick-prev,button.slick-next') || n.querySelector('.slick-initialized')){
              labelArrows(document);
              return;
            }
          }
        }
      }
    }).observe(document.body, {childList:true, subtree:true});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
/* ========= A11y: label Slick slides as options with names & selection ========= */
(function () {
  function labelSlides(rootEl) {
    var root = rootEl || document;
    var sliders = root.querySelectorAll('.slick-initialized');

    sliders.forEach(function (slider) {
      // Ensure the track's container behaves as a listbox
      var list = slider.querySelector('.slick-list');
      if (list) {
        list.setAttribute('role', 'listbox');
        list.setAttribute('aria-live', 'polite');
      }

      var slides = slider.querySelectorAll('.slick-track .slick-slide');
      slides.forEach(function (slide) {
        // role and selection
        slide.setAttribute('role', 'option');
        var isCurrent = slide.classList.contains('slick-current');
        slide.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
        slide.setAttribute('tabindex', isCurrent ? '0' : '-1');

        // Build an accessible name
        var label = '';
        var img = slide.querySelector('img[alt]');
        if (img && img.alt && img.alt.trim()) label = img.alt.trim();

        if (!label) {
          var cap = slide.querySelector('p, .caption, .title, h2, h3');
          if (cap && cap.textContent) label = cap.textContent.trim();
        }
        if (!label) {
          var link = slide.querySelector('a[aria-label]');
          if (link) label = link.getAttribute('aria-label').trim();
        }
        if (!label) {
          // Fallback to index
          var i = slide.getAttribute('data-slick-index');
          var n = isNaN(Number(i)) ? '' : (Number(i) + 1);
          label = n ? ('Slide ' + n) : 'Slide';
        }
        slide.setAttribute('aria-label', label);
      });
    });
  }

  function sweep() { labelSlides(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

  // Re-label on Slick lifecycle events (when jQuery is present)
  if (window.jQuery) {
    var $ = window.jQuery;
    $(document)
      .off('.a11ySlides')
      .on('init.a11ySlides reInit.a11ySlides setPosition.a11ySlides afterChange.a11ySlides breakpoint.a11ySlides',
        '.slick-initialized',
        function () { labelSlides(this); }
      );
  }

  // Catch dynamically injected sliders
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var nodes = muts[i].addedNodes || [];
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('.slick-initialized')) { labelSlides(n); return; }
        if (n.querySelector && n.querySelector('.slick-initialized')) { labelSlides(n); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
